<template>
  <div class=" main-page map-list">
    <Menus title="一带一路服务各国"
           :home="true" />
    <div class="container-flex">
      <ul>
        <li v-for="(item,index) in fList"
            :key="'key-map-list-'+index">
          <router-link :to="item.url">
            <img :src="'/img/ui/foreign/'+index+'.png'">
            <div class="title">
              {{item.title}}
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
export default {
  data () {
    return {
      fList: [{
        url: '/listone?id=5afe9471cf33984ba6a3af39&title=泰国法律',
        title: '泰国法律'
      },
      {
        url: '/listone?id=5afe94f0cf33984ba6a3af8d&title=越南法律',
        title: '越南法律'
      },
      {
        url: '/listone?id=5afe9508cf33984ba6a3af99&title = 老挝法律',
        title: '老挝法律'
      },
      {
        url: '/listone?id=5afe951dcf33984ba764f34b&title=缅甸法律',
        title: '缅甸法律'
      },
      {
        url: '/listone?id=5afe952bcf33984ba764f353&title=柬埔寨法律',
        title: '柬埔寨法律'
      },
      {
        url: '/listone?id=5afe9493cf33984ba6a3af4b&title=新加坡法律',
        title: '新加坡法律'
      },
      {
        url: '/listone?id=5afe94b0cf33984ba6a3af62&title=文莱法律',
        title: '文莱法律'
      },
      {
        url: '/listone?id=5afe944dcf33984ba6a3af1f&title=马来西亚法律',
        title: '马来西亚法律'
      },
      {
        url: '/listone?id=5afe945ecf33984ba6a3af29&title=印度尼西亚法律',
        title: '印度尼西亚法律'
      },
      {
        url: '/listone?id=5afe9480cf33984ba6a3af44&title=菲律宾法律',
        title: '菲律宾法律'
      }
      ]
    }
  },
  async mounted () {
  },
  components: {
    Menus
  }
}
</script>
<style lang="stylus">
.map-list
  padding 0 0 2rem
  ul
    width 15rem
    margin 1.2rem auto 0
    list-style none
    padding 0
    display flex
    flex-wrap wrap
    li
      width 2.7rem
      margin 0 0.3rem 0.4rem 0
      a
        color #fff
        display flex
        width 100%
        height 100%
        flex-direction column
        justify-content center
        align-items center
        height 2.4rem
        background rgba(255, 255, 255, 0.2)
        border-radius 0.1rem
        text-align center
        font-size 0.26rem
        img
          margin 0 auto 0.2rem auto
          width 1.29rem
@media screen and (orientation: portrait)
  .map-list
    ul
      width 100%
      li
        width 50%
</style>
